export const WARNING_CHAR = '⚠';
export const BULLET_POINT_CHAR = '•';